import React, { useEffect, useState, Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import Breadcrumb from '../common/breadcrumb';
import Tablereact from '../common/tabulator/tablereact'
import Loader from '../common/loaderapp';
import Detalle from './detalle'

const Buzon = () => {

    const location = useLocation();
    const [pag_actualizar, setPag_actualizar] = useState([]);
    const [load, setLoad] = useState(false);
    const [datos, setDatos] = useState([]);
    const [autoOpenDone, setAutoOpenDone] = useState(false);

    const folioParam = new URLSearchParams(location.search).get('folio');

    useEffect(() => {
        fetch('/p_buzon', {headers: {'Content-Type': 'application/json'}})
        .then(res => res.json())
        .then(res => {
            // console.log(res);
            setDatos(res)
            setLoad(true)
        })
        .catch(err => console.log('Error:',err))
    }, [pag_actualizar]);

    useEffect(() => {
        if (!folioParam || autoOpenDone || pag_actualizar.length || !datos.length) return;
        const match = datos.find(x => String(x.FOLIO).trim() === String(folioParam).trim());
        setAutoOpenDone(true);
        if (match) {
            setPag_actualizar([match]);
        }
    }, [folioParam, autoOpenDone, pag_actualizar.length, datos]);

    const cabecera = [
        // { Header: <b>ID</b>, accessor: 'ID', style: { textAlign: 'center'}, width:'400', show:false },
        { Header: <b>Folio</b>, accessor: 'FOLIO', style: { textAlign: 'center'}, width:'200', show:true },
        { Header: <b>Nombre</b>, accessor: 'NOMBRE', style: { textAlign: 'center'}, width:'auto', editable:true , show:true},
        { Header: <b>Correo</b>, accessor: 'EMAIL', style: { textAlign: 'center'}, width:'auto', editable:true , show:true},
        { Header: <b>Fecha</b>, accessor: 'DIA', style: { textAlign: 'center'}, width:'170', editable:true , show:true},
    ];

    const cabecera2 = [
        // { Header: <b>ID</b>, accessor: 'ID', style: { textAlign: 'center'}, width:'400', show:false },
        { Header: <b>Nombre</b>, accessor: 'NOMBRE', style: { textAlign: 'center'}, width:'auto', editable:true , show:true},
        { Header: <b>Correo</b>, accessor: 'EMAIL', style: { textAlign: 'center'}, width:'auto', editable:true , show:true},
        { Header: <b>Fecha</b>, accessor: 'DIA', style: { textAlign: 'center'}, width:'170', editable:true , show:true},
    ];

    //const agregar=()=>setPag_actualizar(0)
    const detalle_dato=(dato)=>{setPag_actualizar([dato]);}
    
    return (
        <Fragment>
            <Breadcrumb parent="Inicio" title="Cotización" />
            {
                load ?
                    (!!pag_actualizar.length == 0) ?
                    <Fragment>
                        <div className="container-fluid">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="card-header mb-0-0">
                                        <h5>Cotización</h5>
                                    </div>
                                    <div className="card-body datatable-react">
                                        <Tablereact
                                            myData={datos.filter(x=>x.SITIO=='COTIZADOR')}
                                            cabecera={cabecera}
                                            pageSize={10}
                                            paginacion={true}
                                            buscador='Buscar'
                                            detalle={detalle_dato}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="container-fluid">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="card-header mb-0-0">
                                        <h5>Bolsa de trabajo</h5>
                                    </div>
                                    <div className="card-body datatable-react">
                                        <Tablereact
                                            myData={datos.filter(x=>x.SITIO=='BOLSA DE TRABAJO')}
                                            cabecera={cabecera2}
                                            pageSize={10}
                                            paginacion={true}
                                            buscador='Buscar'
                                            detalle={detalle_dato}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </Fragment>
                    :
                    <Detalle pag_actualizar={pag_actualizar[0]} setPag_actualizar={setPag_actualizar}/>
                :
                <Loader/>
            }
        </Fragment>
    );

}
 
export default Buzon;
